module.exports = __webpack_public_path__ + "img/pr-17.66e50088.png";